import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Row, Col } from "react-bootstrap";
import { getMerchant, exportMerchant } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { MdVpnKey, MdSearch, MdRefresh } from "react-icons/md";
import { AiOutlineCopy } from "react-icons/ai";
import { AiFillFileExcel } from "react-icons/ai";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import config from "config.json";
import moment from "moment";
// import VirtualBank from "./VirtualBank";
import { NotificationManager } from "react-notifications";
import HandyScroll from "app/common/Scroll";

const MerchantList = () => {
  const { dateFormat } = config;

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [affiliateId, setAffiliateId] = useState("");

  const [company, setCompany] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [group, setGroup] = useState("");
  const [DistributorId, setDistributorId] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [memId, setMemId] = useState(0);
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);

  const [searchTrigger, setSearchTrigger] = useState(true);

  const balanceFormatter = (cell, row) => {
    return <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>;
  };

  const dateFormatter = (cell, row) => {
    if (cell) {
      return moment(cell).format(dateFormat);
    }
  };
  const virtualbankHandler = (row) => {
    setSelectedMember(row);
    // this.setState({
    //   selectedMember: row,
    // });
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;
      case "affiliateId":
        setAffiliateId(value);
        break;
      // Add cases for other fields...

      case "company":
        setCompany(value);
        break;

      case "firstName":
        setFirstName(value);
        break;

      case "lastName":
        setLastName(value);
        break;

      case "emailId":
        setEmailId(value);
        break;

      case "status":
        setStatus(value);
        break;

      case "city":
        setCity(value);
        break;

      case "state":
        setState(value);
        break;

      case "country":
        setCountry(value);
        break;

      case "group":
        setGroup(value);
        break;

      case "DistributorId":
        setDistributorId(value);
        break;
      default:
        break;
    }
  };

  const handleGlobalFilterChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;

      // Add cases for other fields...
      default:
        break;
    }
  };

  const refreshFilter = async (e) => {
    setSearch("");
    setAffiliateId("");

    setCompany("");
    setFirstName("");
    setLastName("");
    setEmailId("");
    setStatus("");
    setCity("");
    setState("");
    setCountry("");
    setGroup("");
    setDistributorId("");
    if (document?.getElementById("btn-clear-select")) {
      document.getElementById("btn-clear-select").click();
    }
    setTimeout(async () => {
      await resetTableHandler();
    }, 10);
  };

  const refreshGlobalFilter = async (e) => {
    if (isShowGlobalFilter) {
      setSearch("");
    } else {
      setAffiliateId("");

      setCompany("");
      setFirstName("");
      setLastName("");
      setEmailId("");
      setStatus("");
      setCity("");
      setState("");
      setCountry("");
      setGroup("");
    }
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  const companyFormatter = (cell, row) => {
    return cell.toUpperCase();
  };
  const emailFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.emailId}</div>}
      >
        <span style={{ whiteSpace: "nowrap" }}>
          {row.emailId.substring(0, 10)}...
          <AiOutlineCopy
            cursor={"pointer"}
            className="ms-1"
            onClick={async () => {
              if ("clipboard" in navigator) {
                await navigator.clipboard.writeText(row.emailId);
                NotificationManager.success(
                  "Copied successfully ",
                  "Success",
                  5000
                );
              }
            }}
          />
        </span>
      </Tooltip>
    );
  };

  // Add other formatter functions...

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const columns = [
    {
      dataField: "uniqueIdentity",
      text: "Affiliate Id",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },

    {
      dataField: "company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },

      formatter: companyFormatter,
    },

    {
      dataField: "emailId",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: emailFormatter,
    },
    {
      dataField: "memberMobileNo",
      text: "Mobile No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "joiningDate",
      text: "Joining Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "balance",
      text: "Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "creditLimit",
      text: "Credit Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const expandRow = {
    onlyOneExpanding: true,
    parentClassName: "bg-light",
    renderer: (row) => (
      <>
        <div className="d-flex m-0 b-row">
          <div className="card me-2 ">
            <div className="card-header text-center">Company Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/company-image.png" alt="" />
              </div>
              <div className="col-9">
                <p className="font-weight-bold m-0">
                  ({row.uniqueIdentity ? row.uniqueIdentity?.toUpperCase() : ""}
                  ) {row.company ? row.company?.toUpperCase() : ""}
                  {row.activeMember ? "(Active)" : "(InActive)"}
                </p>
                {row.websiteName ? `Website:${row.websiteName}` : ""}

                <p className="m-0">
                  {row.companyAddress ? row.companyAddress : ""}{" "}
                  {row.stateId ? (row.stateId = "1" ? "WB," : ",") : ""}{" "}
                  {row.countryId ? (row.countryId = "1" ? "IN," : ",") : ""} Pin
                  No: {row.pin ? row.pin : ""}
                </p>
                {row.panNo ? <p className="m-0"> PAN NO.: {row.panNo} </p> : ""}
                {row.companyType ? (
                  <p className="m-0"> Type: {row.companyType}</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="card me-2">
            <div className="card-header text-center">
              Contact Person Information
            </div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/Contact-person.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  {row?.memberFirstName?.toUpperCase()}
                  {row?.memberLastName?.toUpperCase()}
                </p>

                <p className="card-text">{row.emailId}</p>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header text-center">Balance Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/money-wallet.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  Balance: {parseFloat(row.balance).toFixed(2)} INR
                </p>

                <p className="card-text">
                  Limit: {parseFloat(row.creditLimit).toFixed(2)} INR{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <></>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <i style={{ cursor: "pointer" }} className="i-Arrow-Down-2"></i>;
      }
      return <i style={{ cursor: "pointer" }} className="i-Arrow-Right-2"></i>;
    },
  };

  const loadMember = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      DistributorId,
    });

    const response = await getMerchant(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const resetTableHandler = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    const response = await getMerchant(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const exportMember = async () => {
    const query = queryString.getQueryStringFromObj({
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      DistributorId,
      memberType: "Merchant",
    });

    const response = await exportMerchant(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_merchant.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadMember();
  }, [page, sizePerPage, searchTrigger]);

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    setSearchTrigger(!searchTrigger);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await exportMember();
    }, 10);
  };

  return (
    <>
      <Helmet>
        <title>Merchant List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "B2B Merchant List" }]}></Breadcrumb>
      <Row className="mb-2">
        <Col className={isShowGlobalFilter ? "col-12 col-md-10" : "col-md-10"}>
          {/* {isShowGlobalFilter && (
            <div className="input-group mt-1">
              <span className="input-group-text" id="inputGroup-sizing-default">
                Search
              </span>

              <input
                type="text"
                className="form-control"
                id="Search"
                placeholder="Type anything"
                value={search}
                name="search"
                onChange={handleGlobalFilterChange}
                autoComplete="newPassword"
              />
            </div>
          )} */}
        </Col>

        <Col
          className={
            isShowGlobalFilter
              ? "col-md-2 d-flex justify-content-center mt-1"
              : "col-md-2 d-flex justify-content-center mt-1"
          }
        >
          <Button
            variant="primary"
            className="mx-2 "
            onClick={refreshGlobalFilter}
          >
            {isShowGlobalFilter ? (
              <>
                Filter
                <i className="i-Filter-2 ms-1 mt-1" size={15}></i>{" "}
              </>
            ) : (
              <>
                Filter
                <i className="i-Filter-2  mt-1" size={15}></i>
              </>
            )}
          </Button>
          <Button
            variant="primary"
            //  className={"ms-4"}
            onClick={handleExport}
            disabled={!dataCount}
          >
            {isShowGlobalFilter ? (
              <>
                Export
                <AiFillFileExcel size={15} className=" ms-1" />
              </>
            ) : (
              <>
                <AiFillFileExcel size={15} />
              </>
            )}
          </Button>
        </Col>
      </Row>
      <div
        className={isShowGlobalFilter ? "collapse" : "show"}
        id="collapseExample"
      >
        <div className="card card-body rounded border mb-1">
          <div className="row">
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <MdVpnKey />
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="affiliateId"
                  placeholder="AffiliateId"
                  value={affiliateId}
                  // defaultValue={this.state.affiliateId}
                  name="affiliateId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Conference"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="CompanyName"
                  placeholder="Company Name"
                  value={company}
                  name="company"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  placeholder="First Name"
                  value={state.firstName}
                  name="firstName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  placeholder="Last Name"
                  value={lastName}
                  name="lastName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  @
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="emailId"
                  placeholder="Email ID"
                  value={state.emailId}
                  name="emailId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2 ">
              <select
                className="form-control mb-3"
                value={status}
                name="status"
                onChange={handleSearchChanges}
              >
                <option value=""> Select Satus</option>

                <option value="true"> Active</option>
                <option value="false"> InActive</option>
              </select>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="nav-icon i-Business-Mens"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="Group"
                  placeholder="Group"
                  value={group}
                  name="group"
                  onChange={handleSearchChanges}
                  disabled
                />
              </div>
            </div>

            <div className="col-2 d-flex  mb-3">
              <button
                className="btn btn-outline-primary me-3"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={refreshFilter}
              >
                <MdRefresh className="mx-2" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="memId"
            data={data}
            columns={columns}
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            expandRow={expandRow}
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>

      {/* <VirtualBank
        member={selectedMember}
        virtualbankHandler={virtualbankHandler}
      /> */}
    </>
  );
};

export default MerchantList;
